import { FC } from 'react'
import classNames from 'classnames'
import { sectionGapSmall, sectionIndent } from 'project/padding'

type EmpowerEnterprisesType = {}
const items = [
  {
    description:
      'With over 100 enterprise partners, our solutions are built for seamless deployment and scalability. Whether you use our intuitive plug-and-play dashboard or a fully customisable white-label API, our platform integrates effortlessly with your systems, equipping you with everything needed to deliver virtual and registered office solutions at scale. Backed by a dedicated in-house development team, we provide full support from integration to post-launch success.',
    title: 'Integration & Partnership Solutions.',
  },
  {
    description:
      'Our RESTful API integrates directly with your platform, allowing you to embed registered office and virtual office solutions with minimal development time. Full documentation and code samples are available to simplify integration. Sandbox access is provided for safe testing environments before live deployment. Supports Python, Java, Node.js, Ruby, Rust, Swift, and common command-line tools like cURL, HTTPie, Wget, and Ansible. All API interactions are protected with bank-grade encryption. Dedicated developer support is available from sandbox testing to deployment.',
    title: 'API & Developer Tools.',
  },
  {
    description:
      'Our enterprise tools allow you to offer solutions under your own brand with customisable white-label options. Suitable for fintech, accountancy firms, and business service providers looking to expand without additional infrastructure. The Partner Portal offers a plug-and-play solution for immediate access to customer account management, subscription tracking, and real-time metrics. 99.99% uptime ensures continuous service access for your customers.',
    title: 'White-Label & Portal Access.',
  },
  {
    description:
      'Choose the deployment option that fits your business. Our Partner Portal requires no development resources and offers immediate access, while full API integration provides complete control for deeper customisation. Hybrid options combine both for tailored flexibility. Scalable infrastructure grows with your business, supporting one client or 10,000+ users.',
    title: 'Deployment Options.',
  },
  {
    description:
      'Our Reporting & Metrics deliver essential business data at a glance. Real-time dashboards provide instant visibility into customer activity, revenue, subscriptions, and renewals. Financial reports include detailed breakdowns of invoices and subscription summaries. Predictive analytics help you forecast trends and identify growth opportunities.',
    title: 'Reporting & Analytics.',
  },
  {
    description:
      'We work hand-in-hand with many of our partners to offer all of our users access to their services where relevant - whether discounted banking solutions, business-relevant software or workspace tools. Providing our end-users with business value sits at the core of what we do. Adding your service to our Marketplace supports a community and drives your business value and exposure. Interested in partnering? Book a demo or contact us.',
    title: 'Partnership Opportunities.',
  },
]
const EmpowerEnterprises: FC<EmpowerEnterprisesType> = ({}) => {
  return (
    <div
      className={classNames(
        'd-flex flex-column',
        sectionGapSmall,
        sectionIndent,
      )}
    >
      {items.map((item) => (
        <div className='d-flex flex-column gap-2'>
          <h3 className='fw-semibold fs-fluid-20-32'>{item.title}</h3>
          <span className='text-muted fw-semibold fs-fluid-18-24'>
            {item.description}
          </span>
        </div>
      ))}
    </div>
  )
}

export default EmpowerEnterprises
